import printJS from 'print-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { requestPermission } from './firebase/bootstrap';
import './i18n';
import { config } from './lib/boot-config';

if ('serviceWorker' in navigator) {
  console.log('Service workers detected...');
  navigator.serviceWorker.register('/firebase-messaging-sw.js', {
    scope: '/firebase-cloud-messaging-push-scope',
  });
  requestPermission();
} else {
  console.warn('Service Worker not supported');
}

const onAppMessage = async (event) => {
  console.log('index.tsx received event', JSON.stringify(event?.data));
  // preferenze per notifiche push
  if (event?.data?.preference) {
    console.log(
      `Received event.data.preference: "${JSON.stringify(
        event.data.preference,
      )}"`,
    );
    const notification = event.data.preference.pushNotification;
    if (notification === 'on') {
      requestPermission();
    } else {
      /*
la preferenza dovrebbe essere salvata applicativamente in modo da inviare notifiche se:
- app settings: true
- browser notification settings: true
      */
      console.log(
        `Received APP notification preference: "${notification}", ask user to confirm`,
      );
      const permission = await Notification.requestPermission();
      console.log('Browser Notification permission: ', permission);
    }
  }
  // messaggi da dashboard
  if (event?.data?.dashboard) {
    console.log('event.data.dashboard=', event.data.dashboard);
    const url = event.data.dashboard.url;
    if (url) {
      console.log(`Dashboard link: from "${window.location.href}" to "${url}"`);
      // window.location.replace(url);
      window.history.pushState(null, '', url);
      window.location.reload();
    }
  }
  // messaggi da app per aprire/chiudere dialogo di stampa
  if (event.data && event.data.appPrint != null) {
    console.log('event.data.appPrint=', event.data.appPrint);
    if (event.data.appPrint) {
      event.data.base64pdf &&
        printJS({
          printable: event.data.base64pdf,
          type: 'pdf',
          base64: true,
        });
    } else {
      // il listener per la chiusura del dialogo (onafterprint) di stampa non funziona in maniera omogenea tra i browser
      // quindi viene lasciato al chiamante l'onere di eliminare l'iframe usato per la stampa, messaggio {appPrint: false}
      window.document.getElementById('printJS')?.remove();
    }
  }
};

async function pingBackend() {
  const backendBaseUrl = await config.backendBaseUrl('api');
  const url = `${backendBaseUrl}/session/ping`
  fetch(url)
      .then(response => {
          if (!response.ok) {
            console.error(`Error calling ${url}. HTTP status: ${response.status}`);
          }
          return response.json();
      })
      .then(data => {
          console.log(data);
      })
      .catch(error => {
          console.error(`Error calling ${url}`, error);
      });
}
// ogni 5 minuti (300000 ms)
// DISABILITATO ATM
// setInterval(pingBackend, 300000);


function domReadyListener(_event) {
  window.addEventListener('message', onAppMessage, false);
}

function unloadListener(_event) {
  window.removeEventListener('message', onAppMessage, false);
}
window.addEventListener('DOMContentLoaded', domReadyListener);
window.addEventListener('beforeunload', unloadListener);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
